import "./MessageField.scss";
import React from "react";

const MessageField = React.forwardRef(({ label, name, onChange, value, error }, ref) => {
    return (
      <div className="message-field">
        <label className="message-field__label">{label}</label>
        <textarea
          ref={ref}
          name={name}
          value={value}
          onChange={onChange}
          className={`message-field__input ${error ? "message-field__input--error" : ""}`}
          rows="4"
          cols="50"
        />
        {error && (
          <div className="message-field__error">
            <i className="fa-solid fa-circle-xmark"></i>
            <span className="message-field__error--text">{error}</span>
          </div>
        )}
      </div>
    );
  });
  
  export default MessageField;